const testimonials = [
  {
    name: "Rachel M.",
    location: "Coral Springs, FL",
    rating: 5,
    text: "Our daughter's bat mitzvah group trip to Israel was planned for over a year. Three weeks before departure, I checked her passport and it had expired six months earlier. I panicked — the group tour operator said we would lose our deposit if she couldn't travel. Fast Passport Center processed her renewal in four business days. She made the trip, the group stayed intact, and I have never been so grateful for a service in my life. They understood exactly what was at stake.",
    service: "Child Passport Renewal",
  },
  {
    name: "Carlos D.",
    location: "Coral Springs, FL",
    rating: 5,
    text: "I live in the Ramblewood South neighborhood and commute to Fort Lauderdale for work. I had a client meeting in Mexico City in eight days and pulled my passport out for the first time in three years. Expired. I shipped my documents overnight from the FedEx at Coral Square Mall on Monday morning. Fast Passport Center had my new passport back to me by Thursday afternoon. I made my Friday flight without a single issue. Incredible service.",
    service: "Passport Renewal",
  },
  {
    name: "The Thompson Family",
    location: "Coral Springs, FL",
    rating: 5,
    text: "We had a Royal Caribbean cruise booked from Port Everglades for spring break — our kids had been talking about it for months. The night before we were supposed to drive to the port, I checked passports and discovered our youngest son's had expired four months prior. I called Fast Passport Center in a panic at 9 PM. They walked me through everything, I shipped documents the next morning, and his passport arrived the day before our sailing. We made the cruise. I honestly don't know what we would have done without them.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CoralSpringsTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Coral Springs Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Coral Springs and northwest Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}